<template>
  <b-container>
    <s-fieldset class="mt-2">
      <b-row class="pl-3">
        <p class="alarm_details__title">
          {{ $t('sensors.configuration.alarm-details') }}
        </p>
        <info-badge
          class="ml-1">
          <span
            v-html="activeAlarmTooltipContent"
          />
        </info-badge>
      </b-row>
      <b-row>
        <b-col cols="9">
          <label>{{ $t('sensors.configuration.description') }}</label>
        </b-col>
        <b-col cols="3">
          <label class="alarm_details__center">{{ $t('sensors.configuration.exhibition') }}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="9" class="alarm_details__description">
          {{ description }}
        </b-col>
        <b-col cols="3">
          <span class="material-icons alarm_details__center">
            {{ visibleAlarm ? 'visibility' : 'visibility_off' }}
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{ $t('sensors.configuration.classification') }}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <classification
            :classification="alarmClassificationOrDefault"
            :show-label="false"
          />
        </b-col>
      </b-row>
    </s-fieldset>
  </b-container>
</template>

<script>
import InfoBadge from '@/components/icon/InfoBadge';
import Classification from '@/components/Classification';
import { AlarmClassificationType } from 'sigma-mappings';

export default {
  name: 'AlarmDetails',
  components: {
    InfoBadge,
    Classification,
  },
  props: {
    details: {
      type: Object,
      default: () => ({}),
    },
    visibleAlarm: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    alarmClassificationOrDefault() {
      if (!this.visibleAlarm) {
        return null;
      }

      return this.details.classification || AlarmClassificationType.ORDINARY;
    },
    activeAlarmTooltipContent() {
      const text = this.$t('messages.MI095.message', {
        alarmSettingsRef: this.alarmSettingsHighlightContent,
      });
      return `<div>${ text }</div>`;
    },
    alarmSettingsHighlightContent() {
      return `<a class="dm-edit-modal__info-highlight-text" href="${
        this.alarmSettingsUrl
      }" target="_blank">${
        this.$t('admin-panel.tabs-titles.alarm-configurations')
      }</a>`;
    },
    alarmSettingsUrl() {
      const routeData = this.$router.resolve({
        name: 'admin-panel',
        query: {
          activeTabName: 'alarm-configurations',
        },
      });
      return routeData.href;
    },
    description() {
      const contactNumber = (this.details.contactName || '').split(' ')[1];
      const alarmeName = this.$t('sensors.configuration.alarm-name-template', { contactNumber });
      return `${alarmeName} - ${this.details.contactDescription}`;
    },
  },
};

</script>

<style lang="sass" scoped>
.alarm_details
  &__title
    color: var(--color-primary)
    font-size: 1rem
    font-weight: bold
  &__description
    word-break: break-all

.alarm_details__center
  display: flex
  justify-content: center

::v-deep .dm-edit-modal
  &__info-highlight-text
    text-decoration: underline
    color: var(--color-info)

  &:hover
    text-decoration: underline
    color: var(--color-info)
    opacity: .8

</style>
